
import {mapState} from 'vuex';

import { productGroupTypes } from '@/plugins/enums/product';

import Breadcrumbs from '@/components/elements/Breadcrumbs';
import CatalogWrapper from '~/components/catalog/wrapper';
import {generateCategoryUrl, getAllActiveCategories} from '~/plugins/helpers/catalog';
import pageMeta from '~/mixins/pageMeta';

export default {
  name: 'BrandPage',
  components: {
    CatalogWrapper,
    Breadcrumbs,
  },
  mixins: [pageMeta],
  layout: 'main',
  async asyncData({ $api, route, error, redirect }) {
    try {
      const { meta, listing, banners, products, filter } = await $api.general.getPage(route.path, route.query)

      if (!meta || meta?.status > 400) {
        return error({ statusCode: meta?.status || 404 })
      }

      if (meta?.redirect) {
        return redirect(meta.status, meta.redirect)
      }

      const brand = route.params.entityCode
      const response = await $api.brands.getBrands(brand);

      const defaultFilter = {
        brand: [brand],
      }

      const categories = await $api.catalog.getCategories(null, null, defaultFilter);

      const title = response.name

      return {
        pageTitle: meta?.title || '',
        pageMetaData: meta?.data || [],
        pageLinks: meta?.links || [],
        pageText: listing?.text || {},
        products,
        title,
        categories,
        filter,
        defaultFilter,
        excludedFilters: [
          'brand',
        ],
        breadcrumbs: [
          {
            name: 'Главная',
            url: '/',
          },
          {
            name: 'Бренды',
            url: '/brands',
          },
          {
            name: title,
            url: `/brands/${response.code}`,
          },
        ],
        banners: {
          top: banners?.catalog_top || null,
          item: banners?.catalog || null,
        },
        productGroupTypes,

      }
    } catch (e) {
      return error({ statusCode: 404 })
    }
  },
  computed: {
    ...mapState('route', {
      categoryCode: (state) => state.params.category || '',
    }),
    ...mapState('catalog', {
      allCategories: 'allCategories',
    }),
    breadcrumbsList() {
      const activeCategories = getAllActiveCategories(this.allCategories, this.categoryCode);
      const crumbs = [
        ...this.breadcrumbs,
        ...activeCategories.map((item) => ({
          ...item,
          url: generateCategoryUrl(productGroupTypes.CATALOG, this.categoryCode, item.code),
        })),
      ];
      return crumbs;
    },
  },
};
